<router-outlet><ngx-spinner size = "medium"></ngx-spinner></router-outlet>